import { gql } from '@apollo/client';

export const GetMyFilterPresetsQueryName = 'GetMyFilterPresets';

export const GET_MY_FILTER_PRESETS_QUERY = gql`
  query ${GetMyFilterPresetsQueryName} {
    getMyFilterPresets {
      id
      name
      createdAt
      updatedAt
      filter {
        sites
        groups
        materials
        eras
        findTypes
        tags
        hasImages
        hasAmcrId
        createdByMe
        foundAt {
          preset
          from
          to
          timeZone
        }
      }
    }
  }
`;
